"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callTypes = void 0;
var callTypes;
(function (callTypes) {
    callTypes["CONSENT"] = "consent";
    callTypes["SUPPORT"] = "support";
    callTypes["REMINDER"] = "reminder";
    callTypes["PCP_CONFIRMATION"] = "pcpConfirmation";
    callTypes["TEST_FAILED"] = "testFailed";
    callTypes["POST_TEST"] = "postTest";
})(callTypes || (exports.callTypes = callTypes = {}));
